// extracted by mini-css-extract-plugin
module.exports = {"heroScrollWrapper":"HeroScrollWrapper_heroScrollWrapper__egT5h","heroContainer":"HeroScrollWrapper_heroContainer__h7FLn"};